// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__1MBOF","icon":"SortAdornment_icon__2wxER","up":"SortAdornment_up__OkjlS","down":"SortAdornment_down__cYWhO","active":"SortAdornment_active__3V1gv"};